<template>
  <fragment>
    <Title>{{activityName}}</Title>
    <div :key="index" v-for="(item,index) in infoObj.list">
      <Affix :info="item" @handleAffixClick="handleAffixClick" v-if="item.tag=='affix'" />
      <Popup :info="item" v-else-if="item.tag=='popup'" @close="close" :show-popup="showPopup" />
      <Audio :info="item" @handleAudioClick="handleAudioClick" v-else-if="item.tag=='audio'" />
      <Video :info="item" v-else-if="item.tag=='video'" />
      <WantGrid :activityId="activityId" :activityStatus="activityStatus" :openId="openId" :info="item"
        v-else-if="item.tag=='grid'" @handleGridClick="handleGridClick" />
      <Ranking :activityId="activityId" :openId="openId" :info="item" :activityStatus="activityStatus"
        v-else-if="item.tag=='ranking'" />
      <Cimage :info="item" v-else-if="item.tag=='img'" direction="row" @handleImgClick="handleImgClick" />
    </div>
  </fragment>
</template>

<script>
import { isMiniApplets } from "@/utils/browser";
import { getQueryString } from "@/utils/utils";
import { loadScript, encodeSearchParams } from "@/utils/utils";
export default {
  name: "Home",
  computed: {},
  data() {
    return {
      openId: "",
      activityStatus: "",
      infoObj: {},
      showPopup: true,
      activityName: "",
      activityId: "",
      pageNo: "",
      test: '', // 是否测试环境
    };
  },
  mounted() {
    this.activityId = getQueryString("activityId");
    this.pageNo = getQueryString("pageNo");
    this.openId = getQueryString("openId");
    this.test = getQueryString("test")
    this.getPageConfig().then(id => {
      if (id) {
        loadScript(
          `https://jic.talkingdata.com/app/h5/v1?appid=${id}&vn=HDB&vc=1.0.0`
          // `https://jic.talkingdata.com/app/h5/v1?appid=BD6AA2902945494E958A66A8DBA8DC1C&vn=HDB&vc=1.0.0`
        ).then(() => {
          try {
            TDAPP.onEvent("HDB", "活动配置", {
              activityId: this.activityId,
              openId: this.openId,
              pageNo: this.pageNo
            });
          } catch (e) {
            console.log('打点失败', e)
          }
        });
      }
    });
  },
  methods: {
    // 获取配置项
    getPageConfig() {
      return new Promise((resolve, reject) => {
        let params = {
          activityId: this.activityId,
          openId: this.openId,
          pageNo: this.pageNo,
          test: this.test
        };
        this.$ebLoading.show();
        this.$fetch(
          { url: "/ehs/activity/page/config", method: "post" },
          params
        ).then(res => {
          this.$ebLoading.hide();
          if (res.success) {
            this.infoObj = {};
            setTimeout(() => {
              this.infoObj = JSON.parse(res.model.pageContent);
              this.activityStatus = res.model.activityStatus;
              this.activityName = res.model.activityName;
            }, 300);
            resolve(res.model.talkingDataAppId);
          } else {
            if (res.errorCode == "CLA100077") {
              console.log("没有页面");
              return;
            }
            this.$toast({
              styles: {
                maskColor: "rgba(0,0,0,0)",
                background: "rgba(0,0,0,0.4)",
                messageColor: "#fff"
              },
              content: res.errorMessage,
              duration: 2000
            }).then(() => {
              console.log("finish");
            });
          }
        }).finally(() => {
          this.$ebLoading.hide();
        })
      });
    },
    close(val) {
      this.showPopup = val;
    },
    // 热区点击操作统一跳转
    hotAreaHandleClick(val) {
      if (val.jumpType == 2) {
        this.pageNo = val.pagePath;
        this.getPageConfig();
      } else if ([3, 4].includes(val.jumpType)) {
        this.urlFor(val);
      } else if (val.jumpType == 1) {
        // alert("无");
      }
    },
    // 九宫格点击
    handleGridClick(val) {
      console.log(val)
      this.hotAreaHandleClick(val)
    },
    // 固钉点击操作
    handleAffixClick(val) {
      this.hotAreaHandleClick(val);
    },
    // 音频热区点击操作
    handleAudioClick(val) {
      this.hotAreaHandleClick(val);
    },
    // 图片区域点击操作
    handleImgClick(val) {
      this.hotAreaHandleClick(val);
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
